<template>
  <div class="radar_container" id="radar"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "radar_container",
  props: {
    radarData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      datax: null,
    };
  },
  watch: {
    radarData(val) {
      this.datax = val;
      this.getOption();
    },
  },
  computed: {},
  mounted() {},
  methods: {
    getOption() {
      // 避免 document.getElementById 在微前端或切换路由时获取不到 DOM 报错
      let chartDom = document.getElementById("radar") || this.$el;
      if (!chartDom) return;
      var myChart = echarts.init(chartDom);
      let option = {
        radar: [
          {
            indicator: [{ text: "worksCount" }, { text: "citedByCount" }, { text: "i10Index" }, { text: "twoYrMeanCitedness" }, { text: "hindex" }],
            center: ["50%", "50%"],
            radius: 100,
            splitNumber: 4,
            axisName: {
              formatter: "{value}",
              color: "#428BD4",
            },
          },
        ],
        series: [
          {
            type: "radar",
            tooltip: {
              trigger: "item",
            },
            areaStyle: {},
            data: [
              {
                value: this.datax,
                name: "作者统计",
                label: {
                  show: true,
                  formatter: function (params) {
                    return params.value;
                  },
                },
              },
            ],
          },
        ],
      };
      myChart.setOption(option);
    },
  },
};
</script>

<style lang="scss" scope>
.radar_container {
  width: 100%;
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  div {
    cursor: default !important;
  }
}
</style>
